module.exports = __webpack_public_path__ + "img/sup_deposit_jeten2.d30b4e75.jpg";